import {Button} from '@hm/fundamental'
import {mdiCogOutline} from '@mdi/js'
import {useTranslation} from 'react-i18next'

import {LocalColorToggle} from '@refra/modules/common/components/Colors'
import {useKilns} from '@refra/modules/common/providers'
import {getKilnSetupRedirectUrl} from '@refra/modules/common/utils'
import {useUrlParam} from '@refra/modules/routing/hooks'

export const KilnOverviewActions: React.FC = () => {
  const {t} = useTranslation()

  const plantId = useUrlParam('plantCode')
  const {selectedKiln} = useKilns()

  return (
    <div className="flex items-center gap-4" data-cy="kiln_overview_card_actions">
      <LocalColorToggle dataCy="kiln_overview_color_toggle" />
      <Button
        icon={mdiCogOutline}
        variant="tertiary"
        onClick={() =>
          (window.location.href = getKilnSetupRedirectUrl(plantId, selectedKiln.upmId, 'general'))
        }
        data-cy="kiln_overview_settings_button"
      >
        {t('common.setup')}
      </Button>
    </div>
  )
}
